import React, { useEffect, useState } from "react";

import {
  Box,
  ButtonBase,
  Divider,
  Grid2,
  Typography,
  Grid,
} from "@mui/material";
import { connect } from "react-redux";

import { templates_data } from "./templates_data";
import { isHighResolution } from "../../utils/functions";
import CreatePostCustomTemplate from "../CreatePost/CreatePostCustomTemplate";
import { getPostTemplates as getPostTemplatesAction } from "../../redux/slices/postsSlice";

const CustomTemplates = ({
  selected,
  setSelected,
  company,
  customTemplates,
  oneColumn,
  width = "15rem",
  height = "15rem",
  getPostTemplates,
}) => {
  const isHighRes = isHighResolution();

  const getTemplates = async () => {
    try {
      const res = await getPostTemplates(company?.id).unwrap();
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  useEffect(() => {
    if (company?.id) {
      // Make sure company exists before making API call
      getTemplates();
    }
  }, [company?.id]); // Add dependency

  const templates = customTemplates || [];

  return (
    <Grid container spacing={2} width="100%">
      <CreatePostCustomTemplate />

      {templates?.map((t, index) => (
        <Grid
          item
          size={
            oneColumn ? { xs: 12 } : { xs: 12, sm: 6, md: isHighRes ? 3 : 4 }
          }
          key={t?.id || index} // Fallback to index if no id
        >
          <ButtonBase
            sx={{
              width: "95%",
              height: "15rem",
              border:
                selected === t ? "4px solid #1B9CCA" : "4px solid transparent",
              borderRadius: "10px",
              overflow: "hidden",
            }}
            onClick={() => setSelected(t)}
          >
            <img
              src={t}
              alt={`Template ${index}`}
              style={{ width: "250px", height: "15rem", objectFit: "contain" }}
            />
          </ButtonBase>
        </Grid>
      ))}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  company: state.company.company,
  customTemplates: state.posts.custom_templates,
});

const mapDispatchToProps = {
  getPostTemplates: getPostTemplatesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomTemplates);
